/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchPagedResponseDtoTotals
 */
export interface SearchPagedResponseDtoTotals {
    /**
     * 
     * @type {number}
     * @memberof SearchPagedResponseDtoTotals
     */
    all?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchPagedResponseDtoTotals
     */
    companies?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchPagedResponseDtoTotals
     */
    orders?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchPagedResponseDtoTotals
     */
    invoices?: number;
}

/**
 * Check if a given object implements the SearchPagedResponseDtoTotals interface.
 */
export function instanceOfSearchPagedResponseDtoTotals(value: object): value is SearchPagedResponseDtoTotals {
    return true;
}

export function SearchPagedResponseDtoTotalsFromJSON(json: any): SearchPagedResponseDtoTotals {
    return SearchPagedResponseDtoTotalsFromJSONTyped(json, false);
}

export function SearchPagedResponseDtoTotalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPagedResponseDtoTotals {
    if (json == null) {
        return json;
    }
    return {
        
        'all': json['All'] == null ? undefined : json['All'],
        'companies': json['Companies'] == null ? undefined : json['Companies'],
        'orders': json['Orders'] == null ? undefined : json['Orders'],
        'invoices': json['Invoices'] == null ? undefined : json['Invoices'],
    };
}

export function SearchPagedResponseDtoTotalsToJSON(json: any): SearchPagedResponseDtoTotals {
    return SearchPagedResponseDtoTotalsToJSONTyped(json, false);
}

export function SearchPagedResponseDtoTotalsToJSONTyped(value?: SearchPagedResponseDtoTotals | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'All': value['all'],
        'Companies': value['companies'],
        'Orders': value['orders'],
        'Invoices': value['invoices'],
    };
}

